@if (dialog$() !== undefined) {
  @if (chromeless$()) {
    <sol-button
      class="sol-dialog-chromeless-close"
      [type]="SolButtonType.transparent"
      [icon]="SolIcon.remove"
      [attr.aria-label]="'sol-common.close' | translate"
      (click)="onAction('close')"
    />
  } @else {
    <div [class]="titleClass$()">
      {{ dialog$()!.title | translate }}
    </div>
  }
  <div class="sol-dialog-content">
    <ng-content />
  </div>
  @if (leftButtons$().length > 0 || rightButtons$().length > 0) {
    <div class="sol-dialog-actions">
      <div class="sol-dialog-actions-left">
        @for (button of leftButtons$(); track button.id) {
          <sol-button
            [type]="button.type"
            [text]="button.text | translate"
            [loading]="loadingActionId$() === button.id"
            [disabled]="loading$()"
            (click)="onAction(button.id)"
          />
        }
      </div>
      <div class="sol-dialog-actions-right">
        @for (button of rightButtons$(); track button.id) {
          <sol-button
            [type]="button.type"
            [text]="button.text | translate"
            [loading]="loadingActionId$() === button.id"
            [disabled]="loading$()"
            (click)="onAction(button.id)"
          />
        }
      </div>
    </div>
  }
}
